export default function CookiePolicy() {
  return (
    <div style={{ maxWidth: '800px', padding: '0 20px', margin: '150px auto' }}>
      <p>Cookie Policy</p>

      <p>This Cookie Policy was last updated on October 9, 2019</p>

      <p>​</p>

      <p>What are cookies?</p>

      <p>
        Cookies are small text files stored by your browser as you browse the internet. They can be
        used to collect, store, and share data about your activities across websites, including on
        AUMHUM. Cookies also allow us to remember things about your visits to AUMHUM, like your
        preferred language, and to make the site easier to use.
      </p>

      <p>
        We use both session cookies, which expire after a short time or when you close your browser,
        and persistent cookies, which remain stored in your browser for a set period of time. We use
        session cookies to identify you during a single browsing session, like when you log into
        Aumhum. We use persistent cookies where we need to identify you over a longer period, like
        when you request that we keep you signed in.
      </p>

      <p>​</p>

      <p>Why does AUMHUM use cookies and similar technologies?</p>

      <p>
        We use cookies and similar technologies like web beacons, pixel tags, or local shared
        objects (&ldquo;flash cookies&rdquo;), to deliver, measure, and improve our services in
        various ways. We use these cookies both when you visit our site and services through a
        browser and through our mobile app. As we adopt additional technologies, we may also gather
        additional data through other methods.
      </p>

      <p>We use cookies for the following purposes:</p>

      <p>​</p>

      <ul>
        <li>
          To personalize your experience on our website by remembering your preferences and
          settings.
        </li>
        <li>
          To understand how you interact with our website and services to improve their performance
          and functionality.
        </li>
        <li>
          To analyze traffic patterns on our website and services, such as the number of visitors
          and their behavior.
        </li>
        <li>To provide targeted advertisements based on your browsing activities and interests.</li>
        <li>
          To enhance the security of our website and services and to detect and prevent fraudulent
          activities.
        </li>
      </ul>
    </div>
  )
}
